'use client'

import { useContext, useEffect, useRef, useState } from "react";
import FloatDialog from "./_floatDialog";
import { SignContext } from "@/context/signContext";
import InqueryFooter from "../etc/inqueryFooter";
import { useTranslations } from "next-intl";

export default function FloatPasswordChange() {
    const { passwordShow, SetPasswordShow, handlePasswordChangeSubmit } = useContext(SignContext)
    const [id, setId] = useState<string>("")
    const [password, setPassword] = useState<string>("")
    const [password2, setPassword2] = useState<string>("")

    const formRef = useRef<HTMLFormElement>(null)
    const idInputRef = useRef<HTMLInputElement>(null)

    const t = useTranslations("Text")

    return (
        <FloatDialog
            show={passwordShow}
            setShow={SetPasswordShow}
            className="password-change"
        >
            <FloatDialog.Head>{t("비밀번호변경")}</FloatDialog.Head>
            <FloatDialog.Body>
                <form ref={formRef} onSubmit={e => handlePasswordChangeSubmit(e, id, password, password2, () => { SetPasswordShow(false) })}>
                    <div className="password-container">
                        <div className="form-body">
                            <input type="text"
                                name="username"
                                placeholder={t("아이디 또는 이메일")}
                                onChange={e => setId(e.currentTarget.value)}
                                autoFocus
                            />
                            <input type="password"
                                name="password"
                                placeholder={t("변경 비밀번호")}
                                onChange={e => setPassword(e.currentTarget.value)}
                            />
                            <input type="password"
                                name="password2"
                                placeholder={t("비밀번호 확인")}
                                onChange={e => setPassword2(e.currentTarget.value)}
                            />

                        </div>
                        <div className="btns">
                            <button type="submit">{t("비밀번호 변경")}</button>
                            <button type="button" onClick={e=> SetPasswordShow(false)}>{t("닫기")}</button>
                        </div>
                    </div>
                </form>
            </FloatDialog.Body>
        </FloatDialog>
    )
}